import { render, staticRenderFns } from "./AmountsPerCategory.vue?vue&type=template&id=ffbf52c8&scoped=true"
import script from "./AmountsPerCategory.vue?vue&type=script&lang=js"
export * from "./AmountsPerCategory.vue?vue&type=script&lang=js"
import style0 from "./AmountsPerCategory.vue?vue&type=style&index=0&id=ffbf52c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbf52c8",
  null
  
)

export default component.exports